import Axios from 'axios'

const axios = Axios.create({
    baseURL: process.env.API_MAIN_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    headers :{
        Authorization : (typeof window !== 'undefined') ? localStorage.getItem("user") ? 'Bearer '+JSON.parse(localStorage.getItem("user")).token : '' : ''
    }
})

// The API answers a missing or expired session with HTTP 203 and { status: 401 }
// (see app/Exceptions/Handler.php in api-rapideph). 401, and 419 when the CSRF
// token expired along with the session, can also come back as HTTP errors.
export const isUnauthenticated = (response) =>
    response?.status === 401 ||
    response?.status === 419 ||
    response?.data?.status === 401

let redirectingToCmsLogin = false

// An admin session can expire while a CMS page is open. Send the user back to the
// login page instead of leaving the page stuck on a spinner or an empty table.
const handleExpiredCmsSession = (response) => {
    if (typeof window === 'undefined' || redirectingToCmsLogin) return
    // CMS pages only; /cms itself is the login page.
    if (!/^\/cms\/./.test(window.location.pathname)) return
    if (!isUnauthenticated(response)) return

    redirectingToCmsLogin = true
    localStorage.removeItem('token')
    window.location.pathname = '/cms'
}

axios.interceptors.response.use(
    (response) => {
        handleExpiredCmsSession(response)
        return response
    },
    (error) => {
        handleExpiredCmsSession(error.response)
        return Promise.reject(error)
    },
)

export default axios
